
@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4 mb-2">

    <spike-field-text label="Nome" formControlName="shortDescription" errorMessage="Campo non valido" placeholder="Nome" class="mb-2"></spike-field-text>

    <spike-field-wrapper label="Etichetta" >
        @if(formView()){
        <spike-etiquette-list
            noLabelName="default"
            [selectedId]="selectedEtiquetteId()" 
            [etiquetteList]="entityEtiquetteList()" 
            (onSelect)="onSelectEtiquette($event)">
        </spike-etiquette-list>
        }
        @else{
        <spike-etiquette [label]="etiquetteName()!" severity="info" view></spike-etiquette>
        }
    </spike-field-wrapper> 
   
    @if(form().controls['unit']){
        <spike-field-text label="Unità di misura" formControlName="unit" errorMessage="Campo non valido" placeholder="unità di misura"></spike-field-text>
    }

     @if(form().controls['cost']){
        <spike-field-number label="Costo (unità/ora)" formControlName ="cost" mode="currency" currency="EUR" errorMessage="Campo non valido" placeholder="Costo"></spike-field-number>
    }

    <spike-field-text-area label="Descrizione" formControlName="description"> </spike-field-text-area>
    </div>
</form>
}
